export const register = (type = undefined) =>  {
    const base = '/api/v1/register';

    return type
        ? `${base}/${type}`
        : base;
};

export const renew = '/api/v1/register/renew';